export default __webpack_public_path__ + "static/media/Images-05.a7c716fd.png";